module.exports = __webpack_public_path__ + "img/cart.f542df34.svg";